import { createOwnersQuery } from '@hcr/api/optimizely'

import { HTTP_CONFIG } from '../../../../configs'

export const useOwnersQuery = createOwnersQuery(HTTP_CONFIG.API.Optimizely.url)
